import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="container-page pt-28 md:pt-32" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-mid-gray">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={item.to} className="flex items-center gap-1">
              {last ? (
                <span className="font-semibold text-anthracite" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <>
                  <Link
                    to={item.to}
                    className="transition-colors hover:text-anthracite"
                    data-testid={`breadcrumb-${item.to}`}
                  >
                    {item.label}
                  </Link>
                  <ChevronRight className="h-4 w-4 text-mid-gray/60" />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
